import {
  Box,
  Flex,
  Heading,
  NextImage,
  Text,
  useBreakpointValue,
} from '@dapperlabs/core-fe';
import { starterPurchaseLimit } from 'src/general/constants/config';
import { useTranslation } from 'src/lib/translations';

import { InfoText } from '../PackDetailsPage';
import { PacksInDropList } from './components';
import { DistributionExtended } from './types';

interface Props {
  description: string;
  distributions: DistributionExtended[];
  imageSrc?: string;
  title: string;
}

export const StarterPacks = ({
  distributions,
  description,
  title,
  imageSrc,
}: Props) => {
  const { t } = useTranslation();
  const isMdUp = useBreakpointValue({ base: false, md: true });

  return (
    <Box mx={{ base: 4, lg: 24 }} pb={24}>
      <Box
        as='section'
        alignItems='flex-start'
        flexDirection={{ base: 'column', md: 'row' }}
        gap={{ base: 10, lg: 20 }}
        display='flex'
        py={{ md: 24 }}
      >
        <Box
          alignItems='flex-end'
          justifyContent='space-between'
          display='flex'
          width='100%'
        >
          <Flex direction='column'>
            {!!starterPurchaseLimit && (
              <Box>
                <InfoText
                  fontStyle='normal'
                  text={t('PackDetail.StarterPurchaseLimit', {
                    purchaseLimit: starterPurchaseLimit,
                  })}
                  variant='left-accent'
                />
              </Box>
            )}
            <Box flex='0 1 auto' width='75%'>
              <Box>
                <Heading
                  as='h1'
                  mb={2}
                  fontFamily='poster'
                  fontSize={['5xl', '6xl']}
                  fontWeight='500'
                  lineHeight={0.85}
                  textTransform='uppercase'
                >
                  {title}
                </Heading>
                <Text mb={6} fontSize={['md', 'lg']} variant='value'>
                  {description}
                </Text>
              </Box>
            </Box>
          </Flex>
          {imageSrc && isMdUp && (
            <Box flex='0 1 auto' pr={8}>
              <NextImage
                width='350px'
                height='350px'
                alt='pack image'
                src={`https:${imageSrc}`}
              />
            </Box>
          )}
        </Box>
      </Box>
      <PacksInDropList distributions={distributions} isStarter />
    </Box>
  );
};
